import React from 'react';
import { Container, Image, Menu } from 'semantic-ui-react';
import { Link } from "react-router-dom";

export default () => (
  <Menu inverted style={{backgroundColor:'#004165'}} >
    <Container>
      <Menu.Item header>
        <Image style={{backgroundColor:'#004165', 'width':'120px'}}
          src="/crypto2.png"
        />
      </Menu.Item>
      <Menu.Item as="a" name="report">
        <Link to="/report/"> <b> Report </b></Link>
      </Menu.Item>
      <Menu.Item as="a" name="analyse">
        <Link to="/console/"> <b> Analyse </b></Link>
      </Menu.Item>


      <Menu.Menu position="right">
        <Menu.Item as="a" name="login">
          <Link to="/login/"> <b> Login </b> </Link>
        </Menu.Item>

        <Menu.Item as="a" name="register">
          <b> Register </b>
        </Menu.Item>
      </Menu.Menu>
    </Container>
  </Menu>
);
